<template>
  <div id="page_application">
    <div class="rightfixed">
      <a :href="`#part${index+1}`" :class="index==navIndex?'active':''" class="item" v-for="(item,index) in navList" :key="index">{{item}}</a>
    </div>
    <div id="part1" class="full" ref="part1">
      <div class="top">
        <div class="mainTitle1 textbox white">
          <h3>Office</h3>
          <p>Brotex develops different strategies for various challenges and develops personalized configurations to optimize problem-solving based on the function and design of the office space. This includes open space call center solutions, co-working spaces, meeting rooms and video conference rooms, confidential management of C-level offices, leisure and entertainment areas, special telephone booths, and professional office equipment such as voice kiosks.</p>
        </div>
        <div class="cover"></div>
      </div>
      <div class="bottom itembox">
        <swiper class="swiper1" ref="swiper1" :options="swp1opt" :auto-update='true'>
          <swiper-slide class="item" v-for="(item,index) in proList1" :key="index">
            <img :src="`${$https}${item.img}`" alt="">
            <p>{{item.name}}</p>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev sbp1" slot="button-prev"></div>
        <div class="swiper-button-next sbn1" slot="button-next"></div>
      </div>
    </div>
    <div id="part2" class="full" ref="part2">
      <div class="top">
        <div class="mainTitle1 textbox white">
          <h3>School</h3>
          <p>Brotex has a large number of successfully completed projects, including high schools and universities. You can see our quality cases here. For more information, please contact our experts for consultation.</p>
        </div>
        <div class="cover"></div>
      </div>
      <div class="bottom itembox">
        <swiper class="swiper2" ref="swiper2" :options="swp2opt" :auto-update='true'>
          <swiper-slide class="item" v-for="(item,index) in proList2" :key="index">
            <img :src="`${$https}${item.img}`" alt="">
            <p>{{item.name}}</p>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev sbp2" slot="button-prev"></div>
        <div class="swiper-button-next sbn2" slot="button-next"></div>
      </div>
    </div>
    <div id="part3" class="full" ref="part3">
      <div class="top">
        <div class="mainTitle1 textbox white">
          <h3>Auditorium</h3>
          <p>Brotex designs active and passive noise control systems for the auditorium space. High-quality speech performances require high-quality acoustic products to allow customers to enjoy top-notch voice feasts. If you need to provide solutions for your auditorium, you can contact us.</p>
        </div>
        <div class="cover"></div>
      </div>
      <div class="bottom itembox">
        <swiper class="swiper3" ref="swiper3" :options="swp3opt" :auto-update='true'>
          <swiper-slide class="item" v-for="(item,index) in proList3" :key="index">
            <img :src="`${$https}${item.img}`" alt="">
            <p>{{item.name}}</p>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev sbp3" slot="button-prev"></div>
        <div class="swiper-button-next sbn3" slot="button-next"></div>
      </div>
    </div>
    <div id="part4" class="full" ref="part4">
      <div class="top">
        <div class="mainTitle1 textbox white">
          <h3>Commercial</h3>
          <p>Brotex is an expert in permanently solving noise problems. There are different professional methods for reducing noise on the walls, floors, and ceilings of commercial places. Brotex provides standard and custom projects and installations. The continuous solution to the noise problem is completely hidden in human eyes, allowing customers to enjoy the continuous peace and comfort of the commercial places.</p>
        </div>
        <div class="cover"></div>
      </div>
      <div class="bottom itembox">
        <swiper class="swiper4" ref="swiper4" :options="swp4opt" :auto-update='true'>
          <swiper-slide class="item" v-for="(item,index) in proList4" :key="index">
            <img :src="`${$https}${item.img}`" alt="">
            <p>{{item.name}}</p>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev sbp4" slot="button-prev"></div>
        <div class="swiper-button-next sbn4" slot="button-next"></div>
      </div>
    </div>
    <div id="part5" class="full" ref="part5">
      <div class="top">
        <div class="mainTitle1 textbox white">
          <h3>Indoor Stadium</h3>
          <p>Brotex provides many successful cases for indoor stadiums and gymnasiums, specially customized according to the special circumstances of the stadium and customer requirements. If you also need it, please consult our experts.</p>
        </div>
        <div class="cover"></div>
      </div>
      <div class="bottom itembox">
        <swiper class="swiper5" ref="swiper5" :options="swp5opt" :auto-update='true'>
          <swiper-slide class="item" v-for="(item,index) in proList5" :key="index">
            <img :src="`${$https}${item.img}`" alt="">
            <p>{{item.name}}</p>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev sbp5" slot="button-prev"></div>
        <div class="swiper-button-next sbn5" slot="button-next"></div>
      </div>
    </div>
<!--    <div id="part6" class="full">-->
<!--      <div class="top">-->
<!--        <div class="mainTitle1 textbox white">-->
<!--          <h3>Indoor Stadium</h3>-->
<!--          <p>Brotex provides many successful cases for indoor stadiums and gymnasiums, specially customized according to the special circumstances of the stadium and customer requirements. If you also need it, please consult our experts.</p>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="bottom itembox">-->
<!--        <swiper class="swiper6" ref="swiper6" :options="swp6opt" :auto-update='true'>-->
<!--          <swiper-slide class="item" v-for="(item,index) in proList6" :key="index">-->
<!--            <img :src="item.img" alt="">-->
<!--            <p>{{item.name}}</p>-->
<!--          </swiper-slide>-->
<!--        </swiper>-->
<!--        <div class="swiper-button-prev sbp6" slot="button-prev"></div>-->
<!--        <div class="swiper-button-next sbn6" slot="button-next"></div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import {WOW} from 'wowjs'
import * as $request from "../api/index";
export default {
  name: "Application",
  metaInfo:{
    title:'Guangdong Brotex Acoustic Technology Co.,Ltd | Application',
  },
  data(){
    return{
      navList:['OFFICE','SCHOOL','AUDITORIUM','COMMERCIAL','INDOOR STADIUM',],
      navIndex:0,
      proList1:[
        {
          img:require('../assets/img/office1.jpg'),
          name:'office1',
        },
        {
          img:require('../assets/img/office2.jpg'),
          name:'office2',
        },
        {
          img:require('../assets/img/office3.jpg'),
          name:'office3',
        },
        {
          img:require('../assets/img/office4.jpg'),
          name:'office4',
        },
        {
          img:require('../assets/img/office5.jpg'),
          name:'office5',
        },
      ],
      proList2:[
        {
          img:require('../assets/img/cinema1.jpg'),
          name:'cinema1',
        },
        {
          img:require('../assets/img/cinema2.jpg'),
          name:'cinema2',
        },
        {
          img:require('../assets/img/cinema3.jpg'),
          name:'cinema3',
        },
        {
          img:require('../assets/img/cinema4.jpg'),
          name:'cinema4',
        },
        {
          img:require('../assets/img/cinema5.jpg'),
          name:'cinema5',
        },
        {
          img:require('../assets/img/cinema6.jpg'),
          name:'cinema6',
        },
      ],
      proList3:[
        {
          img:require('../assets/img/school1.jpg'),
          name:'school1',
        },
        {
          img:require('../assets/img/school2.jpg'),
          name:'school2',
        },
        {
          img:require('../assets/img/school3.jpg'),
          name:'school3',
        },
        {
          img:require('../assets/img/school4.jpg'),
          name:'school4',
        },
        {
          img:require('../assets/img/school5.jpg'),
          name:'school5',
        },
        {
          img:require('../assets/img/school6.jpg'),
          name:'school6',
        },
      ],
      proList4:[
        {
          img:require('../assets/img/theater1.jpg'),
          name:'theater1',
        },
        {
          img:require('../assets/img/theater2.jpg'),
          name:'theater2',
        },
        {
          img:require('../assets/img/theater3.jpg'),
          name:'theater3',
        },
        {
          img:require('../assets/img/theater4.jpg'),
          name:'theater4',
        },
      ],
      proList5:[
        {
          img:require('../assets/img/hall1.jpg'),
          name:'hall1',
        },
        {
          img:require('../assets/img/hall2.jpg'),
          name:'hall2',
        },
        {
          img:require('../assets/img/hall3.jpg'),
          name:'hall3',
        },
        {
          img:require('../assets/img/hall4.jpg'),
          name:'hall4',
        },
        {
          img:require('../assets/img/hall5.jpg'),
          name:'hall5',
        },
      ],
      proList6:[
        {
          img:require('../assets/img/indoor1.jpg'),
          name:'indoor1',
        },
        {
          img:require('../assets/img/indoor2.jpg'),
          name:'indoor2',
        },
        {
          img:require('../assets/img/indoor3.jpg'),
          name:'indoor3',
        },
        {
          img:require('../assets/img/indoor4.jpg'),
          name:'indoor4',
        },
        {
          img:require('../assets/img/indoor5.jpg'),
          name:'indoor5',
        },
      ],
      swp1opt:{
        slidesPerView: 3,
        spaceBetween: 25,
        slidesPerColumnFill:'row',
        navigation: {
          nextEl: '.sbn1',
          prevEl: '.sbp1'
        },
      },
      swp2opt:{
        slidesPerView: 3,
        spaceBetween: 25,
        slidesPerColumnFill:'row',
        navigation: {
          nextEl: '.sbn2',
          prevEl: '.sbp2'
        },
      },
      swp3opt:{
        slidesPerView: 3,
        spaceBetween: 25,
        slidesPerColumnFill:'row',
        navigation: {
          nextEl: '.sbn3',
          prevEl: '.sbp3'
        },
      },
      swp4opt:{
        slidesPerView: 3,
        spaceBetween: 25,
        slidesPerColumnFill:'row',
        navigation: {
          nextEl: '.sbn4',
          prevEl: '.sbp4'
        },
      },
      swp5opt:{
        slidesPerView: 3,
        spaceBetween: 25,
        slidesPerColumnFill:'row',
        navigation: {
          nextEl: '.sbn5',
          prevEl: '.sbp5'
        },
      },
      swp6opt:{
        slidesPerView: 3,
        spaceBetween: 25,
        slidesPerColumnFill:'row',
        navigation: {
          nextEl: '.sbn6',
          prevEl: '.sbp6'
        },
      },
      scrollTopo: 0,
      catList:[],
    }
  },
  watch:{
    scrollTopo(newval){
      // console.log(newval)
      const a=this.$refs.part1.scrollHeight,b=this.$refs.part2.scrollHeight,
          c=this.$refs.part3.scrollHeight,d=this.$refs.part4.scrollHeight;
          // e=this.$refs.part5.scrollHeight;
      let arr=[
        Number(-50+0),
        Number(-50+a),
        Number(-50+a+b),
        Number(-50+a+b+c),
        Number(-50+a+b+c+d),
        // Number(-50+a+b+c+d+e),
      ];
      // console.log(window.scrollY)
      for(let i=0;i<arr.length;i++){
        if(newval>=arr[i] && this.navIndex!=i){
          this.navIndex=i
        }
      }
    }
  },
  methods:{
    async getProList(id,index){
      console.log(id,index)
      await $request.getShops(id,1,12).then(res=>{
        switch (index){
          case 0:
            this.proList1=res.datas
            // console.log(this.proList1)
            break;
          case 1:
            this.proList2=res.datas
            // console.log(this.proList2)
            break;
          case 2:
            this.proList3=res.datas
            // console.log(this.proList3)
            break;
          case 3:
            this.proList4=res.datas
            // console.log(this.proList4)
            break;
          case 4:
            this.proList5=res.datas
            // console.log(this.proList5)
            break;
        }

        // console.log(this.proList)
      })
    },
  },
  created() {
    this.$emit('getnav',3)
    $request.getCats().then(res=>{
      res.forEach(val=>{
        if(val.name=='Application'){
          this.catList=val.sonList
          for(let i=0;i<this.catList.length;i++){
            this.getProList(this.catList[i].id,i)
          }
          // console.log(this.catList)
        }
      })
    })

  },
  mounted() {
    this.$nextTick(()=>{
      let wow = new WOW({
        live:false
      })
      wow.init()
      window.onscroll = ()=>{
        this.scrollTopo = document.documentElement.scrollTop || document.body.scrollTop;
      }
    })
  },
  destroyed() {
    window.removeEventListener('scroll',{})
  }
}
</script>

<style lang="less" scoped>
#page_application{
  .rightfixed{position: fixed;right: -2px;top: 15%;z-index: 101;text-align: right;
    .item{padding: 15px 30px;background: @main-c1;margin-bottom: 10px;border-radius: 100px 0 0 100px;font: 14px Poppins-SemiBold;cursor: pointer;border: 2px solid @main-c1;display: block;
      &:after{content: '>';margin-left: 10px;}
      &:hover,&.active{background: white;}
    }
  }
  [id^='part']{padding: 0;
    .top{background: no-repeat 50% 50%/cover fixed;height: 800px;padding: 280px;padding-bottom: 0;position: relative;z-index: 1;
      .cover{position: absolute;top: 0;left: 0;z-index: -1;background: rgba(0,0,0,.4);width: 100%;height: 100%;}
    }
    .bottom{padding: 70px 280px;position: relative;
      [class^='swiper']{width: 100%;}
      img{width: 100%;height: 321px;object-fit: cover;}
      p{text-align: center;font: 22px Poppins-SemiBold;background: #F5F5F5;padding: 20px 0;color: @main-c4;}
      .swiper-button-prev{left: 10%!important;}
      .swiper-button-next{right: 10%!important;}
    }
  }
  #part1{
    .top{height: 910px;background-image: url('../assets/img/application_bg1.jpg');}
  }
  #part2{
    .top{background-image: url('../assets/img/application_bg2.jpg');}
  }
  #part3{
    .top{background-image: url('../assets/img/application_bg3.jpg');}
  }
  #part4{
    .top{background-image: url('../assets/img/application_bg4.jpg');}
  }
  #part5{
    .top{background-image: url('../assets/img/application_bg5.jpg');}
  }
  #part6{
    .top{background-image: url('../assets/img/application_bg6.jpg');}
  }
}
</style>